import { render, staticRenderFns } from "./AttendanceWarningModal.vue?vue&type=template&id=f22061d4&scoped=true"
import script from "./AttendanceWarningModal.vue?vue&type=script&lang=js"
export * from "./AttendanceWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22061d4",
  null
  
)

export default component.exports